(function ($) {
  var initializeTestinomialBlock = function () {
    $(".post-carousel").slick({
      dots: true,
      infinite: true,
      arrows: false,
      speed: 500,
      centered: true,
      slidesToShow: 3,
      slidesToScroll: 3,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 576,
          settings: {
            dots: true,
            infinite: true,
            arrows: false,
            speed: 500,
            centered: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            dots: true,
            infinite: true,
            arrows: false,
            speed: 500,
            centered: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
      ],
    });
  };
  // Initialize each block on page load (front end).
  $(document).ready(function () {
    // console.log("Page loaded");
    initializeTestinomialBlock();
  });
})(jQuery);
